import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Layout } from 'fronton-react';
import {
  HeaderSection,
  HeaderImageStructure,
  OtherSection,
} from 'common/components';
import { useIsInViewport, useScrollToElement } from 'common/hooks';
import { useRegionIdSelector } from 'modules/model-json';
import { ConsultationSection } from 'remotes/consultation-section';
import { PromoBlock } from 'remotes/promo-block';
import { SpecialOffer } from 'remotes/special-offer';
import { getActiveBrandName, WindowsBrandsSection } from './windows-brands-section';
import { WindowsDesignPanel } from './windows-design-panel';
import { WindowsInteriorGallerySection } from './windows-interior-gallery-section';
import { WindowsProjectGallerySection } from './windows-project-gallery-section';
import { WindowsTypeSection } from './windows-type-section';
import { WindowsUtpCardSection } from './windows-utp-card-section';
import {   WindowsQuestionSection,
 } from './windows-question-section';
import {
  WINDOWS_CDN_PATH,
  WINDOWS_ELEMENT_BLOCK,
  WINDOWS_LANDING_NAME,
} from '../windows-constants';

/**
 * Вью страницы "Окна на заказ"
 */
export const OldWindows: React.FC = () => {
  const { t } = useTranslation();
  const { elRef, onScrollToElement } = useScrollToElement();
  const regionId = useRegionIdSelector();
  const [activeBrand, setActiveBrand] = useState(getActiveBrandName(regionId));

  const isConsultationFormVisible = useIsInViewport(elRef, { threshold: 0 });

  return (
    <>
      <HeaderSection
        bgColor="#9BACC7"
        description={t('header.description')}
        img={
          {
            ldSrcSet: `${WINDOWS_CDN_PATH}/header/header-new-ld.jpg/header-new-ld.jpg`,
            dSrcSet: `${WINDOWS_CDN_PATH}/header/header-new-d.jpg/header-new-d.jpg`,
            tSrcSet: `${WINDOWS_CDN_PATH}/header/header-new-t.jpg/header-new-t.jpg`,
            mSrcSet: `${WINDOWS_CDN_PATH}/header/header-new-m.jpg/header-new-m.jpg`,
            title: t('header.title'),
            alt: t('header.title'),
          } as HeaderImageStructure
        }
        mediaType="image"
        title={t('header.title')}
      />
      <WindowsDesignPanel
        isConsultationFormVisible={isConsultationFormVisible}
        onConsultationSignupBtnClick={onScrollToElement}
      />
      <Layout>
        <PromoBlock elementBlock={WINDOWS_ELEMENT_BLOCK} />
        <SpecialOffer onModalBtnClick={onScrollToElement} elementBlock={WINDOWS_ELEMENT_BLOCK} />
        <WindowsUtpCardSection onConsultationSignupBtnClick={onScrollToElement} />
      </Layout>
      <WindowsTypeSection onConsultationSignupBtnClick={onScrollToElement} />
      <Layout>
        {activeBrand && (
          <WindowsBrandsSection brandName={activeBrand} onChangeBrand={setActiveBrand} regionId={regionId} />
        )}
        <WindowsProjectGallerySection onConsultationSignupBtnClick={onScrollToElement} />
        <WindowsInteriorGallerySection
          brandName={activeBrand}
          onConsultationSignupBtnClick={onScrollToElement}
          regionId={regionId}
        />
        <ConsultationSection
          consultationType="WINDOW"
          elementBlock={WINDOWS_ELEMENT_BLOCK}
          elementText={t('consultation-section.title')}
          isCommentVisible
          sectionRef={(el: HTMLElement | null) => {
            elRef.current = el;
          }}
          sectionText={t('consultation-section.description') || ''}
          sectionTitle={t('consultation-section.title')}
        />
        <WindowsQuestionSection />
      </Layout>
      <OtherSection
        elementBlock={`${WINDOWS_ELEMENT_BLOCK} / other`}
        landingName={WINDOWS_LANDING_NAME}
        promotionName={`${WINDOWS_ELEMENT_BLOCK}_bottom`}
      />
    </>
  );
};
